import { connect } from 'react-redux';
import { setEditorType as setEditorTypeAction } from '@Pages/RetroSynthesis/DrawStructure/actions';
import {
  showSupplierPreferencesChangedToastMessage as showSupplierPreferencesChangedToastMessageAction,
  showCommercialSubstancesPreferencesChangedToastMessage as showCommercialSubstancesPreferencesChangedToastMessageAction,
} from './actions';
import Preferences from './Preferences';

const mapDispatchToProps = {
  setEditorType: setEditorTypeAction,
  showSupplierPreferencesChangedToastMessage: showSupplierPreferencesChangedToastMessageAction,
  showCommercialSubstancesPreferencesChangedToastMessage: showCommercialSubstancesPreferencesChangedToastMessageAction,
};

export default connect(null, mapDispatchToProps)(Preferences);
